module.exports = __webpack_public_path__ + "img/NO_IMG.08441b70.png";